<template>
  <div class="gallery view-media">
    <Photo
      v-if="type === 'photo'"
      :isEmmit="true"
      @closeView="closeView"
      :mediaDetail="mediaDetail"
    />
    <Video
      v-if="type === 'video'"
      :isEmmit="true"
      @closeView="closeView"
      :mediaDetail="mediaDetail"
    />
  </div>
</template>

<script>
import Photo from "@/components/Media/Photo.vue";
import Video from "@/components/Media/Video.vue";
export default {
  name: "RootMedia",
  components: { Photo, Video },
  created() {
    this.type = (this.$route.params && this.$route.params.type) || null;
  },
  async mounted() {
    this.mediaDetail = await this.$store.dispatch(
      "getMediaDetailWithCourse",
      this.$route.params.mediaId
    );
  },
  data() {
    return {
      mediaDetail: null,
      type: null,
    };
  },
  computed: {},
  methods: {
    closeView() {
      if(this.mediaDetail.courseCountry) {
        this.$router.push({
          name: "courses.videosPhotos",
          params: {
            coursesCountry: this.mediaDetail.courseCountry,
            namegolf: this.mediaDetail.courseSlug,
          },
          meta: {
            tab: 5,
            title: "Videos Photos",
          },
        });
      } else {
        this.$router.push({
          name: "newsfeed",
        });
      }
    },
  },
};
</script>

